/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrder {
  beepId?: number;
  billingCity?: string;
  billingCityCode?: number;
  billingCountry?: string;
  billingCountryCode?: number;
  billingInfoId?: number;
  billingLabel?: string;
  billingNeighborhood?: string;
  billingPhone?: string;
  billingPostalCode?: string;
  billingState?: string;
  billingStateCode?: number;
  billingStreet?: string;
  billingStreetExtensions?: string;
  billingStreetNumber?: string;
  chaveNFE?: string;
  cookieId?: number;
  creditCardPaymentId?: number;
  dateCreated?: Date;
  dateSyncERP?: Date;
  dateUpdated?: Date;
  discountTotal?: number;
  editionId?: number;
  invoiceMessage?: string;
  invoiceNumber?: number;
  invoiceSeries?: string;
  invoiceStatus?: number;
  itemsTotal?: number;
  manuallyReceveidEdition?: boolean;
  nfeeAuthorizationDate?: Date;
  nfse?: string;
  orderPointsTotal?: number;
  orderTotal?: number;
  paymentGuid?: string;
  paymentOrderId?: number;
  personCPF?: number;
  personEmail?: string;
  personId?: number;
  personName?: string;
  productVariantIds?: Array<number>;
  purchaseOrderId?: number;
  rps?: number;
  shippingCity?: string;
  shippingCityCode?: number;
  shippingCompanyId?: number;
  shippingCountry?: string;
  shippingCountryCode?: number;
  shippingInfoId?: number;
  shippingLabel?: string;
  shippingNeighborhood?: string;
  shippingOrderId?: number;
  shippingOrderStatus?: number;
  shippingOrderType?: ShippingOrder.ShippingOrderTypeEnum;
  shippingOrderTypeId?: number;
  shippingPhone?: string;
  shippingPostalCode?: string;
  shippingServiceId?: number;
  shippingState?: string;
  shippingStateCode?: number;
  shippingStreet?: string;
  shippingStreetExtensions?: string;
  shippingStreetNumber?: string;
  shippingTotal?: number;
  subscriberEditionId?: number;
  taxTemplateId?: number;
  trackingCode?: string;
  trackingCodeCount?: number;
  trackingCodeImportId?: number;
  trackingStatus?: string;
  trackingStatusDate?: Date;
}
export namespace ShippingOrder {
  export type ShippingOrderTypeEnum =
    | 'SUBSCRIBER_EDITION'
    | 'RESEND'
    | 'TRADE'
    | 'GIFT'
    | 'BFLU_INCENTIVE_EDITION'
    | 'BFLU_INCENTIVE'
    | 'AWARD'
    | 'SUBSCRIPTION'
    | 'BRINDE_MGM_COUPON';
  export const ShippingOrderTypeEnum = {
    SUBSCRIBEREDITION: 'SUBSCRIBER_EDITION' as ShippingOrderTypeEnum,
    RESEND: 'RESEND' as ShippingOrderTypeEnum,
    TRADE: 'TRADE' as ShippingOrderTypeEnum,
    GIFT: 'GIFT' as ShippingOrderTypeEnum,
    BFLUINCENTIVEEDITION: 'BFLU_INCENTIVE_EDITION' as ShippingOrderTypeEnum,
    BFLUINCENTIVE: 'BFLU_INCENTIVE' as ShippingOrderTypeEnum,
    AWARD: 'AWARD' as ShippingOrderTypeEnum,
    SUBSCRIPTION: 'SUBSCRIPTION' as ShippingOrderTypeEnum,
    BRINDEMGMCOUPON: 'BRINDE_MGM_COUPON' as ShippingOrderTypeEnum
  };
}
